// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f3371aa8801fc54aeccf4ce40f36804123c7eeba/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};